import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ClaimSetReportedEvent extends EventV2<object> {}
